// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"policy_checkbox_checkboxContainer__nFyCf","policyText":"policy_checkbox_policyText__WzzmS"};